import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { platforms } from '@/mocks/strategix';

export default function Platforms() {
  return (
    <section className="relative w-full px-5 md:px-10 py-20 md:py-28 bg-background-100/50">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="С какими платформами"
          title="Запускаем рекламу там, где живёт ваша аудитория"
          description="Основной формат — продвижение сообществ на разных площадках. Дополнительно занимаемся продвижением сайтов и каналов, а для максимального охвата подключаем ключевые рекламные каналы — от таргета до контекста."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {platforms.map((platform, index) => (
            <Reveal key={platform.name} delay={index * 70} className="h-full">
              <div className="group h-full p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-400/60 transition-colors">
                <span
                  className="w-14 h-14 flex items-center justify-center rounded-md text-[26px] leading-none transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: `${platform.color}1F`, color: platform.color }}
                >
                  <i className={platform.icon} aria-hidden="true" />
                </span>
                <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{platform.name}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{platform.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}